module.exports = __webpack_public_path__ + "static/media/logo.19413356.jpg";